"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFieldResultByStatType = exports.getStatTypeList = exports.StatTranslate = exports.StatType = void 0;
const i18n_1 = require("../../exports/i18n");
const lodash_1 = require("lodash");
const store_1 = require("../../exports/store");
const field_types_1 = require("../../types/field_types");
const number_1 = require("../../utils/number");
const field_1 = require("./field");
var StatType;
(function (StatType) {
    StatType[StatType["None"] = 0] = "None";
    StatType[StatType["CountAll"] = 1] = "CountAll";
    StatType[StatType["Empty"] = 2] = "Empty";
    StatType[StatType["Filled"] = 3] = "Filled";
    StatType[StatType["Unique"] = 4] = "Unique";
    StatType[StatType["PercentEmpty"] = 5] = "PercentEmpty";
    StatType[StatType["PercentFilled"] = 6] = "PercentFilled";
    StatType[StatType["PercentUnique"] = 7] = "PercentUnique";
    StatType[StatType["Sum"] = 8] = "Sum";
    StatType[StatType["Average"] = 9] = "Average";
    StatType[StatType["Max"] = 10] = "Max";
    StatType[StatType["Min"] = 11] = "Min";
    // LatestDate = 10,
    // EarliestDate = 11,
    StatType[StatType["DateRangeOfDays"] = 12] = "DateRangeOfDays";
    StatType[StatType["DateRangeOfMonths"] = 13] = "DateRangeOfMonths";
    // TotalAttachmentSize = 14,
    // CountAttachments = 15,
    StatType[StatType["Checked"] = 14] = "Checked";
    StatType[StatType["UnChecked"] = 15] = "UnChecked";
    StatType[StatType["PercentChecked"] = 16] = "PercentChecked";
    StatType[StatType["PercentUnChecked"] = 17] = "PercentUnChecked";
})(StatType = exports.StatType || (exports.StatType = {}));
exports.StatTranslate = {
    [StatType.None]: (0, i18n_1.t)(i18n_1.Strings.stat_none),
    [StatType.CountAll]: (0, i18n_1.t)(i18n_1.Strings.stat_count_all),
    [StatType.Empty]: (0, i18n_1.t)(i18n_1.Strings.stat_empty),
    [StatType.Filled]: (0, i18n_1.t)(i18n_1.Strings.stat_fill),
    [StatType.Unique]: (0, i18n_1.t)(i18n_1.Strings.stat_uniqe),
    [StatType.PercentEmpty]: (0, i18n_1.t)(i18n_1.Strings.stat_percent_empty),
    [StatType.PercentFilled]: (0, i18n_1.t)(i18n_1.Strings.stat_percent_filled),
    [StatType.PercentUnique]: (0, i18n_1.t)(i18n_1.Strings.stat_percent_unique),
    [StatType.Sum]: (0, i18n_1.t)(i18n_1.Strings.stat_sum),
    [StatType.Average]: (0, i18n_1.t)(i18n_1.Strings.stat_average),
    [StatType.Max]: (0, i18n_1.t)(i18n_1.Strings.stat_max),
    [StatType.Min]: (0, i18n_1.t)(i18n_1.Strings.stat_min),
    [StatType.DateRangeOfDays]: (0, i18n_1.t)(i18n_1.Strings.stat_date_range_of_days),
    [StatType.DateRangeOfMonths]: (0, i18n_1.t)(i18n_1.Strings.stat_date_range_of_months),
    [StatType.Checked]: (0, i18n_1.t)(i18n_1.Strings.stat_checked),
    [StatType.UnChecked]: (0, i18n_1.t)(i18n_1.Strings.stat_un_checked),
    [StatType.PercentChecked]: (0, i18n_1.t)(i18n_1.Strings.stat_percent_checked),
    [StatType.PercentUnChecked]: (0, i18n_1.t)(i18n_1.Strings.stat_percent_un_checked),
};
const getStatTypeList = (field, state) => {
    return field_1.Field.bindContext(field, state).statTypeList;
};
exports.getStatTypeList = getStatTypeList;
const statCountAll = (records) => {
    return records.length;
};
const statEmpty = (cellValues) => {
    return cellValues.filter(cellValue => {
        return cellValue == null || (Array.isArray(cellValue) && !cellValue.length);
    }).length;
};
const statFilled = (cellValues) => {
    return cellValues.filter(cellValue => {
        return Array.isArray(cellValue) ? cellValue.length : (cellValue != null);
    }).length;
};
const statUnique = (cellValues, _field) => {
    const _cellValue = cellValues.map(item => {
        return JSON.stringify(item);
    });
    const result = (0, lodash_1.uniq)(_cellValue).length;
    return result;
};
// numeric field calculation
const statSum = (cellValues, field, state) => {
    let res = (0, lodash_1.sum)(cellValues) || 0;
    const instance = field_1.Field.bindContext(field, state);
    if (instance.basicValueType === field_types_1.BasicValueType.Array) {
        res = [res];
    }
    return instance.cellValueToString(res);
};
// numeric field calculation
const statAverage = (cellValues, field, state) => {
    // cell is empty, not counted in total
    const total = cellValues.filter(cv => typeof cv === 'number').length;
    let res = (0, lodash_1.sum)(cellValues) / total;
    if (field.type === field_types_1.FieldType.Rating) {
        return res.toFixed(2).toString();
    }
    const instance = field_1.Field.bindContext(field, state);
    if (instance.basicValueType === field_types_1.BasicValueType.Array) {
        res = [res];
    }
    return instance.cellValueToString(res);
};
// Number & date field calculation
const statMax = (cellValues, field, state) => {
    let res = cellValues.reduce((accumulator, cellValue) => Math.max(accumulator, typeof cellValue === 'number' ? cellValue : -Infinity), -Infinity);
    if (!isFinite(res))
        return Infinity;
    const instance = field_1.Field.bindContext(field, state);
    if (instance.basicValueType === field_types_1.BasicValueType.Array)
        res = [res];
    return instance.cellValueToString(res);
};
// Number & date field calculation
const statMin = (cellValues, field, state) => {
    let res = cellValues.reduce((accumulator, cellValue) => Math.min(accumulator, typeof cellValue === 'number' ? cellValue : Infinity), Infinity);
    if (!isFinite(res))
        return -Infinity;
    const instance = field_1.Field.bindContext(field, state);
    if (instance.basicValueType === field_types_1.BasicValueType.Array)
        res = [res];
    return instance.cellValueToString(res);
};
const statDateRangeOfDays = (cellValues) => {
    const max = cellValues.reduce((accumulator, cellValue) => Math.max(accumulator, cellValue || -Infinity), -Infinity);
    const min = cellValues.reduce((accumulator, cellValue) => Math.min(accumulator, cellValue || Infinity), Infinity);
    if (!isFinite(min))
        return 0;
    const rangeDayTime = max - min;
    return Math.floor(rangeDayTime / (60 * 60 * 24 * 1000));
};
const statDateRangeOfMonths = (cellValues) => {
    const max = cellValues.reduce((accumulator, cellValue) => Math.max(accumulator, cellValue || -Infinity), -Infinity);
    const min = cellValues.reduce((accumulator, cellValue) => Math.min(accumulator, cellValue || Infinity), Infinity);
    if (!isFinite(min))
        return 0;
    const maxDate = new Date(max);
    const minDate = new Date(min);
    let year = maxDate.getFullYear() - minDate.getFullYear();
    let month = maxDate.getMonth() - minDate.getMonth();
    let date = maxDate.getDate() - minDate.getDate();
    let hours = maxDate.getHours() - minDate.getHours();
    let minutes = maxDate.getMinutes() - minDate.getMinutes();
    let seconds = maxDate.getSeconds() - minDate.getSeconds();
    const milliSeconds = maxDate.getMilliseconds() - minDate.getMilliseconds();
    milliSeconds < 0 && seconds--;
    seconds < 0 && minutes--;
    minutes < 0 && hours--;
    hours < 0 && date--;
    date < 0 && month--;
    if (month < 0) {
        month += 12;
        year--;
    }
    return year * 12 + month;
};
/**
 * Get column result based on calculation type
 */
const getFieldResultByStatType = (statType, records, field, snapshot, state) => {
    let cellValues = records.map(recId => {
        return store_1.Selectors.getCellValue(state, snapshot, recId, field.id);
    });
    const instance = field_1.Field.bindContext(field, state);
    const shouldFlat = instance.isComputed && instance.basicValueType === field_types_1.BasicValueType.Array;
    switch (statType) {
        case StatType.CountAll:
            return statCountAll(records);
        case StatType.Empty:
        case StatType.UnChecked:
            return statEmpty(cellValues);
        case StatType.Filled:
        case StatType.Checked:
            return statFilled(cellValues);
        case StatType.Unique:
            if (shouldFlat)
                cellValues = cellValues.flat(1);
            return statUnique(cellValues, field);
        case StatType.PercentEmpty:
        case StatType.PercentUnChecked:
            return (0, number_1.toFixed)(statEmpty(cellValues) * 100 / records.length) + '%';
        case StatType.PercentFilled:
        case StatType.PercentChecked:
            return (0, number_1.toFixed)(statFilled(cellValues) * 100 / records.length) + '%';
        case StatType.PercentUnique:
            if (shouldFlat)
                cellValues = cellValues.flat(1);
            return (0, number_1.toFixed)(statUnique(cellValues, field) * 100 / (shouldFlat ? cellValues.length : records.length)) + '%';
        case StatType.Sum:
            if (shouldFlat)
                cellValues = cellValues.flat(1);
            return statSum(cellValues, field, state);
        case StatType.Average:
            if (shouldFlat)
                cellValues = cellValues.flat(1);
            return statAverage(cellValues, field, state);
        case StatType.Max:
            if (shouldFlat)
                cellValues = cellValues.flat(1);
            return statMax(cellValues, field, state);
        case StatType.Min:
            if (shouldFlat)
                cellValues = cellValues.flat(1);
            return statMin(cellValues, field, state);
        case StatType.DateRangeOfDays:
            if (shouldFlat)
                cellValues = cellValues.flat(1);
            return statDateRangeOfDays(cellValues);
        case StatType.DateRangeOfMonths:
            if (shouldFlat)
                cellValues = cellValues.flat(1);
            return statDateRangeOfMonths(cellValues);
        default: {
            return null;
        }
    }
};
exports.getFieldResultByStatType = getFieldResultByStatType;
//# sourceMappingURL=stat.js.map